import Recipe from '@/models/Recipe'
import BaseCollection from '@/models/collections/BaseCollection'

export default class RecipesList extends BaseCollection {
  options () {
    return {
      model: Recipe
    }
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/recipes`
    }
  }
}
